import { OwaDate, getDate, isSameDay, formatShortMonthDay } from 'owa-datetime';
import { isToday } from 'owa-observable-datetime';

export default function monthCellHeaderTextFormatter(
    dateRangeStartDate: OwaDate,
    shouldShowWeekMonthName?: () => boolean
): (date: OwaDate) => string {
    return (date: OwaDate) => {
        const dayOfMonth = getDate(date);
        let shouldShowMonthString =
            dayOfMonth == 1 || isSameDay(date, dateRangeStartDate) || isToday(date);
        let shouldShow = shouldShowWeekMonthName?.() ?? true;
        if (!shouldShow) {
            shouldShowMonthString = false;
        }
        return shouldShowMonthString ? formatShortMonthDay(date) : dayOfMonth.toString();
    };
}
